export const propertyTypes = {
    GET_PROPERTY_LIST: 'GET_PROPERTY_LIST',
    GET_PROPERTY_LIST_ERROR: 'GET_PROPERTY_LIST_ERROR'
}